import { Link } from '@tanstack/react-router';

export function LandingPage() {
  return (
    <main className="min-h-screen bg-background text-foreground">
      <div className="mx-auto max-w-5xl px-6 py-10 lg:px-10">
        <header className="flex items-center justify-between border-b border-border pb-5">
          <p className="text-sm font-semibold tracking-[0.18em]">FIDUCIARYFILE</p>
          <div className="flex items-center gap-4 text-sm">
            <Link data-jr-key="landing-sign-in" className="text-muted-foreground hover:text-foreground" to="/sign-in">
              Sign in
            </Link>
            <Link
              data-jr-key="landing-sign-up"
              className="border border-primary bg-primary px-3 py-2 text-primary-foreground"
              to="/sign-up"
            >
              Create account
            </Link>
          </div>
        </header>
        <section className="grid gap-12 py-16 lg:grid-cols-[1.05fr_.95fr] lg:items-center">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
              Confidential filing operations
            </p>
            <h1 className="mt-5 max-w-xl text-5xl font-semibold leading-[1.05] tracking-[-0.04em]">
              A guarded paper file for every return.
            </h1>
            <p className="mt-6 max-w-lg text-lg leading-8 text-muted-foreground">
              Prepare, approve, submit, and track annual estate and trust tax returns with a clear chain of custody.
            </p>
          </div>
          <article className="border border-border bg-card p-6">
            <div className="flex items-start justify-between border-b border-border pb-5">
              <div>
                <p className="text-[11px] uppercase tracking-[0.16em] text-muted-foreground">Anonymized return file</p>
                <h2 className="mt-2 text-xl font-semibold">Estate return · 2025</h2>
              </div>
              <span className="border border-primary/40 px-2 py-1 text-xs text-primary">In review</span>
            </div>
            <dl className="mt-5 grid gap-4 text-sm">
              <div className="flex justify-between border-b border-border/70 pb-3">
                <dt className="text-muted-foreground">File reference</dt>
                <dd className="font-medium">FF—•••—1842</dd>
              </div>
              <div className="flex justify-between border-b border-border/70 pb-3">
                <dt className="text-muted-foreground">Last handoff</dt>
                <dd className="font-medium">Approval queue</dd>
              </div>
              <div className="flex justify-between">
                <dt className="text-muted-foreground">Record status</dt>
                <dd className="font-medium">Ready for review</dd>
              </div>
            </dl>
          </article>
        </section>
        <p className="max-w-2xl border-t border-border pt-6 text-sm leading-7 text-muted-foreground">
          Built for fiduciaries and their teams: the right record, the right rules, and the right accountable handoff at
          every step.
        </p>
      </div>
    </main>
  );
}
